<template>
    <div class="pfts">
        <div class="toolbar mb30 f-r-s">
            <div class="operation f-r-s">
                <el-select v-model="mgu_id" size="small" filterable remote clearable placeholder="请输入会员姓名或手机号" :remote-method="remoteMethodVip" :loading="loading" @change="onSearchClick">
                    <el-option v-for="item in vip_opts" :key="item.mgu_id" :label="item.txt" :value="item.mgu_id"></el-option>
                </el-select>
                <el-select v-model="trainer_mgu_id" size="small" filterable remote clearable placeholder="请输入教练姓名或手机号" :remote-method="remoteMethodTrainer" :loading="loading" style="margin-left:10px;" @change="onSearchClick">
                    <el-option v-for="item in trainer_opts" :key="item.trainer_mgu_id" :label="item.txt" :value="item.trainer_mgu_id"></el-option>
                </el-select>
                <el-button slot="append" class="search-btn" type="success" size="small" style="margin-left:10px;" @click="onSearchClick">查询</el-button>
            </div>
            <div class="filters">
                <el-date-picker v-model="date_range" type="daterange" align="right" size="small" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="drOpts" @change="onSearchClick"></el-date-picker>
            </div>
        </div>

        <div class="fc_gray fs_small">注：搜索选择会员、教练后，查询相应的静态测评。</div>
        <el-table :data="list" style="width: 100%" v-loading="loading" size="small" class="mb12">
            <el-table-column type="index" width="60" :index="index => index + 1 + pageStart" label="序号" />
            <el-table-column label="创建" width="200">
                <template slot-scope="scope">
                    <div class="txtrow">时间：{{ scope.row.create_dt | formatDt }}</div>
                    <div class="txtrow">会员：{{scope.row.vip.name}}<span v-if="scope.row.vip.phoneno">（{{scope.row.vip.phoneno}}）</span></div>
                    <div class="txtrow">教练：{{scope.row.trainer.name}}<span v-if="scope.row.trainer.nickname|| scope.row.trainer.phoneno">（{{scope.row.trainer.nickname}} {{scope.row.trainer.phoneno | formatPhoneno}}）</span></div>
                </template>
            </el-table-column>
            <el-table-column label="正面">
                <template slot-scope="scope">
                    <div>
                        <span>{{3==scope.row.front_head?'头前倾；':7==scope.row.front_head?'头后仰；':''}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="左侧">
                <template slot-scope="scope">
                    <div>
                        <span>{{7==scope.row.left_body_isline?'全身不垂直；':''}}</span>
                        <span>{{3==scope.row.left_head?'头前倾；':7==scope.row.left_head?'头后仰；':''}}</span>
                        <span>{{2==scope.row.left_cervical?'颈椎过于前屈；':5==scope.row.left_cervical?'颈椎过于伸直；':''}}</span>
                        <span>{{2==scope.row.left_scapula?'左侧肩关节内旋；':3==scope.row.left_scapula?'左侧圆肩；':7==scope.row.left_scapula?'右侧圆肩；':8==scope.row.left_scapula?'右侧肩关节内旋；':''}}</span>
                        <span>{{5==scope.row.left_thoracic?'胸椎过度伸直；':8==scope.row.left_thoracic?'胸椎过于后曲；':''}}</span>
                        <span>{{5==scope.row.left_lumbar?'腰椎过度伸直；':8==scope.row.left_lumbar?'腰椎过于后曲；':''}}</span>
                        <span>{{3==scope.row.left_pelvicjoint?'盆骨前倾；':7==scope.row.left_pelvicjoint?'盆骨后倾；':''}}</span>
                        <span>{{3==scope.row.left_hipjoint?'髋关节屈曲；':7==scope.row.left_hipjoint?'髋关节伸展；':''}}</span>
                        <span>{{1==scope.row.left_kneejoint?'膝关节超伸；':''}}</span>
                        <span>{{1==scope.row.left_anklejoint?'踝关节足背屈；':3==scope.row.left_anklejoint?'踝关节跖屈；':''}}</span>
                    </div>
                    <div>{{scope.row.left_remark}}</div>
                </template>
            </el-table-column>
            <el-table-column label="右侧">
                <template slot-scope="scope">
                    <div>
                        <span>{{7==scope.row.right_body_isline?'全身不垂直；':''}}</span>
                        <span>{{3==scope.row.right_head?'头前倾；':7==scope.row.right_head?'头后仰；':''}}</span>
                        <span>{{2==scope.row.right_cervical?'颈椎过于前屈；':5==scope.row.right_cervical?'颈椎过于伸直；':''}}</span>
                        <span>{{2==scope.row.right_scapula?'左侧肩关节内旋；':3==scope.row.right_scapula?'左侧圆肩；':7==scope.row.right_scapula?'右侧圆肩；':8==scope.row.right_scapula?'右侧肩关节内旋；':''}}</span>
                        <span>{{5==scope.row.right_thoracic?'胸椎过度伸直；':8==scope.row.right_thoracic?'胸椎过于后曲；':''}}</span>
                        <span>{{5==scope.row.right_lumbar?'腰椎过度伸直；':8==scope.row.right_lumbar?'腰椎过于后曲；':''}}</span>
                        <span>{{3==scope.row.right_pelvicjoint?'盆骨前倾；':7==scope.row.right_pelvicjoint?'盆骨后倾；':''}}</span>
                        <span>{{3==scope.row.right_hipjoint?'髋关节屈曲；':7==scope.row.right_hipjoint?'髋关节伸展；':''}}</span>
                        <span>{{1==scope.row.right_kneejoint?'膝关节超伸；':''}}</span>
                        <span>{{1==scope.row.right_anklejoint?'踝关节足背屈；':3==scope.row.right_anklejoint?'踝关节跖屈；':''}}</span>
                    </div>
                    <div>{{scope.row.right_remark}}</div>
                </template>
            </el-table-column>
            <el-table-column label="背面">
                <template slot-scope="scope">
                    <div>
                        <span>{{3==scope.row.back_head?'头前倾；':7==scope.row.back_head?'头后仰；':''}}</span>
                        <span>{{2==scope.row.back_shoulder?'左侧耸肩；':4==scope.row.back_shoulder?'左侧塌肩；':6==scope.row.back_shoulder?'右侧塌肩；':8==scope.row.back_shoulder?'右侧耸肩 ；':''}}</span>
                        <span>{{4==scope.row.back_scapula?'肩带前引；':6==scope.row.back_scapula?'肩带缩回；':''}}</span>
                        <span>{{3==scope.row.back_upperlimbs?'上肢左侧间隙大；':7==scope.row.back_upperlimbs?'上肢右侧间隙大；':''}}</span>
                        <span>{{1==scope.row.back_thoracic_lumbar?'胸腰椎C形；':3==scope.row.back_thoracic_lumbar?'胸腰椎S形 ；':''}}</span>
                        <span>{{1==scope.row.back_pelvicjoint?'盆骨前倾；':''}}</span>
                        <span>{{3==scope.row.back_glutealline?'臀线左腿腿长；':7==scope.row.back_glutealline?'臀线右腿腿长；':''}}</span>
                        <span>{{2==scope.row.back_hipjoint?'髋关节内旋；':4==scope.row.back_hipjoint?'髋关节内收；':6==scope.row.back_hipjoint?'髋关节外展；':8==scope.row.back_hipjoint?'髋关节外旋；':''}}</span>
                        <span>{{1==scope.row.back_anklejoint?'踝关节足背屈；':3==scope.row.back_anklejoint?'踝关节跖屈；':''}}</span>
                        <span>{{3==scope.row.back_foot?' 足部内翻；':7==scope.row.back_foot?' 足部外翻；':9==scope.row.back_foot?' 足部足扁平；':''}}</span>
                    </div>
                    <div>{{scope.row.back_remark}}</div>
                </template>
            </el-table-column>
        </el-table>
        <div class="bottom-toolbar" style="display: flex;align-items: center;justify-content: flex-start;">
            <div class="pagination">
                <el-pagination background layout="prev, pager, next" :total="total" :page-size="page_size" v-if="total > page_size" @current-change="onPageChange" :current-page.sync="page_ix">
                </el-pagination>
            </div>
        </div>

    </div>
</template>
<script>
    import {
        mapState
    } from "vuex";
    import {
        formatPhoneno
    } from "@/utils/formatData"
    const defaultVip = {
        mgu_id: 0,
        txt: '未选择会员'
    }
    const defaultTrainer = {
        trainer_mgu_id: 0,
        txt: '未选择教练'
    }
    export default {
        name: "survey_pfts",
        data() {
            return {
                remote_mgu_id: 0,

                gym_id: 0,

                vip_opts: [{
                    ...defaultVip
                }],
                trainer_opts: [{
                    ...defaultTrainer
                }],

                drOpts: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                date_range: '',

                mgu_id: 0,
                trainer_mgu_id: 0,

                loading: false,
                list: [],
                total: 0,
                page_ix: 1,
                page_size: 10
            };
        },
        computed: {
            ...mapState(["user"]),
            pageStart() {
                return (this.page_ix - 1) * this.page_size;
            },
        },
        watch: {
            "$route.query.mgu_id": {
                immediate: true,
                handler() {
                    if ('/survey_pfts' == this.$route.path && this.$route.query.mgu_id && this.$route.query.mgu_id != this.remote_mgu_id) {
                        this.remote_mgu_id = this.$route.query.mgu_id
                        this.remoteMethodVip()
                    }
                }
            }
        },
        mounted() {
            this.gym_id = this.user.gym.id
            if (!this.$route.query.mgu_id) {
                this.remoteMethodVip()
            }
            this.remoteMethodTrainer()
        },
        methods: {
            remoteMethodVip(query) {
                setTimeout(() => {
					let _data = {
						gym_id: this.gym_id
					}
					if (query) {
						_data['cdit'] = query
					} else {
						if (this.$route.query.mgu_id) {
							_data['mgu_id'] = this.$route.query.mgu_id
						}
					}
                    this.loading = true
                    this.$post("/admin/Survey/remoteVips", _data).then(res => {
                        if (res.rst == 0) {
                            this.vip_opts = [{
                                ...defaultVip
                            }]
                            res = res.data
                            if (res && res.length > 0) {
                                res.forEach((item, ix) => {
                                    this.vip_opts.push({
                                        mgu_id: item.id,
                                        txt: item.vip.name + '（' + formatPhoneno(item.vip.phoneno) + '）'
                                    })
                                    if (this.remote_mgu_id && this.remote_mgu_id == item.id) {
                                        this.mgu_id = item.id
                                    }
                                })
                            }
                        }
                    }).finally(() => {
                        this.loading = false
                        this.getList()
                    })
                }, 250)
            },
            remoteMethodTrainer(query) {
                setTimeout(() => {
                    this.loading = true;
                    this.$post("/admin/Survey/remoteTrainers", {
                        gym_id: this.gym_id,
                        cdit: query
                    }).then(res => {
                        if (res.rst == 0) {
                            this.trainer_opts = [{
                                ...defaultTrainer
                            }]
                            res = res.data
                            if (res && res.length > 0) {
                                res.forEach((item, ix) => {
                                    this.trainer_opts.push({
                                        trainer_mgu_id: item.id,
                                        txt: item.trainer.name + '（' + item.trainer.nickname + ' ' + formatPhoneno(item.trainer.phoneno) + '）'
                                    })
                                })
                            }
                        }
                    }).finally(() => {
                        this.loading = false;
                    })
                }, 250)
            },
            getList() {
                this.loading = true;
                let _data = {
                    gym_id: this.gym_id,
                    mgu_id: this.mgu_id,
                    trainer_mgu_id: this.trainer_mgu_id,
                    page_ix: this.page_ix,
                    page_size: this.page_size
                }
                if (this.date_range) {
                    _data.from_dt = Math.floor(new Date(this.date_range[0]).getTime() / 1000)
                    _data.to_dt = Math.floor(new Date(this.date_range[1]).getTime() / 1000) + 86399
                }
                this.$post("/admin/Survey/queryPfts", _data)
                    .then(res => {
                        if (res.rst == 0) {
                            this.list = res.data.data;
                            this.total = res.data.total;
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            onSearchClick() {
                this.page_ix = 1;
                this.getList();
            },
            onPageChange(page) {
                this.page_ix = page;
                this.getList();
            }
        }
    };
</script>
<style lang="less" scoped>
    .pfts {
        .toolbar {
            .operation {
                .search-ipt {
                    width: 300px;
                }

                .add-btn {
                    width: 100px;
                }
            }

            .filters {
                margin-left: 50px;
            }

            .tip {
                height: 20px;
                font-size: 20px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #eb5753;
            }
        }

        .form-wrap {
            .tip {
                color: #ed991f;
            }
        }
    }
</style>